module OnlineDPR.Application.Client.ControlPanelDpr

open Elmish
open Fable.Core
open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Client.Template
open OnlineDPR.Application.Client.Components
open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.Translations

[<Emit("DownloadLegalPath")>]
let downloadLegalPath : string = jsNative

type Msg =
| SyncCheckboxChecked of DprClubOptions
| ClubOptionsUpdated of Result<bool, string>

let postDataCmd (data:DprClubOptions) =
    Cmd.OfPromise.either(Http.postData APIUrls.UpdateClubOptions) data (ClubOptionsUpdated) ((fun e -> Error (string e) ) >> ClubOptionsUpdated)

let update msg (model:ControlPanelDprModel) =
    match msg with
    | SyncCheckboxChecked options -> let newData = {options with SyncDataFromOnfitAllowed = true}
                                     let updatedList = ListHelper.replace (fun (x:DprClubOptions) -> x.ClubNumber = options.ClubNumber) (fun _ -> newData) model.ClubOptions
                                     match updatedList with
                                     | Some o -> {model with ClubOptions = o}, postDataCmd newData
                                     | None -> failwithf "Entry to replace with clubnumber %s not found" options.ClubNumber
    | ClubOptionsUpdated r -> model, []

let editDprError (m:EditRowModel) =
    match m.Date.ValidationMessage, m.ErrorMessage with
    | Some s, _ -> validationMessage s |> errorMessage
    | None, Some s -> errorMessage s
    | None, None -> []
    |> ofList

let viewInTemplate (model:ControlPanelDprModel) dispatch =
    article [ Class "content"]
            [ div [ Class "title-block" ]
                  [ h3 [ Class "title" ]
                       [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_Title] ] ]
              section [ Class "section" ]
                      [ div [ ClassName "card card-default" ]
                            [ div [ ClassName "card-block" ]
                                  [ p [ ClassName "title" ]
                                      [ a [ Href PageUrls.dprReport ] [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_Report_Link_Text] ] ] ] ]
                        div [ ClassName "card card-default" ]
                            [ div [ ClassName "card-header" ]
                                  [ div [ ClassName "header-block" ]
                                        [ p [ ClassName "title" ]
                                            [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_Legal_Title] ] ] ]
                              div [ ClassName "card-block" ]
                                  [ p [] [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_Legal_Text] ]
                                    p [] [ a [ Href downloadLegalPath ] [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_Legal_Link] ] ] ] ]
                        div [ ClassName "card card-default" ]
                            [ div [ ClassName "card-header" ]
                                  [ div [ ClassName "header-block" ]
                                        [ p [ ClassName "title" ]
                                            [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Title] ] ] ]
                              div [ ClassName "card-block" ]
                                  [ p [] [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Text] ]
                                    table [ ClassName "table table-bordered table-hover flip-content"
                                            Id "DprClubSettingsTable" ]
                                          [ thead [ ClassName "flip-header" ]
                                                  [ tr [] [ th [] [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Table_Club] ]
                                                            th [] [ str CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn] ] ] ]
                                            tbody [] (model.ClubOptions
                                                     |> List.map (fun club -> let title = if club.IsBlacklisted then
                                                                                            CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_Blacklisted]
                                                                                          else if club.SyncDataFromOnfitAllowed then
                                                                                            CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_OptOutMessage]
                                                                                          else
                                                                                            CurrentTranslations.Translations.[TranslationKey.ControlPanel_Dpr_ClubSettings_Table_OptIn_OptInMessage]
                                                                              tr [] [ td [] [ str club.ClubNumber ]
                                                                                      td [] [ slider club.SyncDataFromOnfitAllowed (club.IsBlacklisted || club.SyncDataFromOnfitAllowed) (Some (fun _ -> dispatch (SyncCheckboxChecked club))) None (Some title) ] ])) ] ] ] ] ]

let view (model:ControlPanelDprModel) dispatch =
    templateView model.Template [] [] (viewInTemplate model dispatch)
